<template>
  <div id="home" class="content"
    v-on:click="showMore = null; configOpen = false;">
      <div class="contentTop">
      <div class="lthHeaderCnt">
        <div class="lBtn add newFolder" v-on:click="newFolder">
          New Folder
        </div>
        <div class="searchCnt">
          <form v-on:submit.prevent="search">
            <input type="text" class="field" placeholder="Search media..."
              v-on:input="search" v-model="query">
            <button></button>
          </form>
          <div class="pageBtn refresh" v-on:click="getData"></div>
        </div>
        <div class="pagination">
          <div class="pageInfo" v-on:click="gotoPage">
            <template v-if="allMedia.length > 0">
              {{((page * limit) + 1).toLocaleString('id')}}-{{((page
              * limit) + allMedia.length).toLocaleString('id')}}
            </template><template v-else>0</template> dari
            {{total.toLocaleString('id')}}</div>
          <div :class="{pageBtn: 1, pagePrev: 1, disabled: page === 0}"
            v-on:click="prevPage"></div>
          <div :class="{pageBtn: 1, pageNext: 1, disabled: ((page
            * limit) + allMedia.length) >= total}"
            v-on:click="nextPage"></div>
          <div class="pageBtn viewType viewGrid" v-on:click="setViewType('grid')"
            :class="{active: viewType === 'grid'}"></div>
          <div class="pageBtn viewType viewList" v-on:click="setViewType('list')"
            :class="{active: viewType === 'list'}"></div>
          <div class="pageBtn config" :class="{open: configOpen}"
            v-on:click.stop="configOpen = !configOpen">
            <div class="ddCnt flex" v-if="configOpen" v-on:click.stop="doNothing">
              <div class="ddItem">
                <h4>Filetype</h4>
                <div class="radioCnt">
                  <div class="radioItem" v-on:click="setFiletype('all')">
                    <div :class="{radio: 1, checked: filetype === 'all'}"></div>
                    All
                  </div>
                  <div class="radioItem" v-on:click="setFiletype('audio')">
                    <div :class="{radio: 1, checked: filetype === 'audio'}"></div>
                    Audio
                  </div>
                  <div class="radioItem" v-on:click="setFiletype('video')">
                    <div :class="{radio: 1, checked: filetype === 'video'}"></div>
                    Video
                  </div>
                  <div class="radioItem" v-on:click="setFiletype('pdf')">
                    <div :class="{radio: 1, checked: filetype === 'pdf'}"></div>
                    PDF
                  </div>
                  <div class="radioItem" v-on:click="setFiletype('html')">
                    <div :class="{radio: 1, checked: filetype === 'html'}"></div>
                    HTML
                  </div>
                  <div class="radioItem" v-on:click="setFiletype('image')">
                    <div :class="{radio: 1, checked: filetype === 'image'}"></div>
                    Image
                  </div>
                  <div class="radioItem" v-on:click="setFiletype('directory')">
                    <div :class="{radio: 1, checked: filetype === 'directory'}"></div>
                    Directory
                  </div>
                </div>
              </div>
              <div class="ddItem">
                <h4>Item Per Page</h4>
                <div class="radioCnt">
                  <div class="radioItem" v-on:click="setItemPerPage(25)">
                    <div :class="{radio: 1, checked: limit === 25}"></div>
                    25 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(50)">
                    <div :class="{radio: 1, checked: limit === 50}"></div>
                    50 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(100)">
                    <div :class="{radio: 1, checked: limit === 100}"></div>
                    100 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(150)">
                    <div :class="{radio: 1, checked: limit === 150}"></div>
                    150 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(250)">
                    <div :class="{radio: 1, checked: limit === 250}"></div>
                    250 item per page
                  </div>
                </div>
              </div>
              <div class="ddItem ddItemFull" v-if="tabActive !== 'static' && 1>2">
                <h4>View</h4>
                <div class="radioCnt">
                  <div class="radioItem" v-on:click="setViewType('grid')">
                    <div :class="{radio: 1, checked: viewType === 'grid'}"></div>
                    Grid View
                  </div>
                  <div class="radioItem" v-on:click="setViewType('list')">
                    <div :class="{radio: 1, checked: viewType === 'list'}"></div>
                    List View
                  </div>
                  <div class="radioItem" v-on:click="setViewType('detailed')" v-if="1>2">
                    <div :class="{radio: 1, checked: viewType === 'detailed'}"></div>
                    Detailed View
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="pageBtn more" :class="{open: moreOpen}"
            v-if="1>2"></div>
        </div>
      </div>
      <div class="dirNav" v-if="dir">
        <div class="backBtn" v-on:click="dirBack"></div>
        <h4>{{dir.name}}</h4>
      </div>
      <div class="tabCnt" v-else>
        <div class="tab tab1 published" :class="{active: tabActive === 'all'}"
          v-on:click="selectTab('all')">All Media</div>
        <div class="tab tab2 starred" :class="{active: tabActive === 'starred'}"
          v-on:click="selectTab('starred')">Starred</div>
        <!--
        <div class="tab tab4 draft" :class="{active: tabActive === 'static'}"
          v-on:click="selectTab('static')">Static</div>
        -->
        <div class="tab tab99 deleted" :class="{active: tabActive === 'deleted'}"
          v-on:click="selectTab('deleted')">Deleted</div>
      </div>
    </div>

    <perfect-scrollbar class="listingCntSc">
      <div class="loading" v-if="loading"></div>
      <div class="tabbleWrapper" v-else>
        <div class="mediaCnt" :class="viewType">
          <div class="mediaHeader">Name<div class="mediaType">Media Type</div></div>
          <div v-for="(media, index) in allMedia" :key="index"
            class="mediaItemCnt" :class="{optionOpen: showMore === media.id,
            directory: media.type === 'directory'}" v-on:click="mediaDetail(index, media)">
            <div class="mediaItem">
              <div class="mediaThumb" :style="{'background-image': `url(${media.imageSm})`}"
                v-if="media.type === 'image'" :class="{png: (media.mimetype === 'image/png'
                && media.alphaPercent >= 10)
                || media.mimetype === 'image/svg+xml', gif: media.mimetype === 'image/gif'}"/>
              <div class="mediaThumb" :style="{'background-image': `url(${media.thumb})`}"
                v-else-if="media.type === 'video' && media.mimetype === 'video/youtube'"/>
              <div class="mediaThumb" :style="{'background-image': `url(${media.mainThumb})`}"
                v-else-if="media.type === 'video'"/>
              <div class="mediaThumb" :style="{'background-image': `url(${media.cover})`}"
                v-else-if="media.type === 'pdf' && media.cover"/>
              <div class="mediaThumb directory"
                v-else-if="media.type === 'directory'"/>
              <div class="mediaThumb general xls" v-else-if="['application/x-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
                .includes(media.mimetype)"></div>
              <div class="mediaThumb general zip"
                v-else-if="media.mimetype === 'application/zip'"></div>
              <div class="mediaThumb general pdf"
                v-else-if="media.mimetype === 'application/pdf' && !media.cover"></div>
              <div class="mediaThumb general" :class="media.type" v-else></div>
              <div class="more" v-on:click.stop="showMore = media.id">
                <div class="actionCnt" v-if="showMore === media.id">
                  <div class="actionItem" v-if="media.type === 'image'"
                    v-on:click.stop="copyUrl(media)">
                    <img src="../assets/copy.png"> Copy media url
                  </div>
                  <div class="actionItem" v-on:click.stop="moveToFolder(media, index)">
                    <img src="../assets/move-to-folder.png"> Move to folder
                  </div>
                  <div class="divider"></div>
                  <div class="actionItem red" v-on:click.stop="deleteMedia2(media, index)"
                    v-if="media.isDeleted === 1">
                    <img src="../assets/delete.png"> Delete Permanently
                  </div>
                  <div class="actionItem red" v-on:click.stop="deleteMedia(media, index)"
                    v-else>
                    <img src="../assets/delete.png"> Delete
                  </div>
                </div>
              </div>
              <div class="star" :class="{starred: media.featured === 1}"
                v-on:click.stop="featured(index, media)"></div>
              <div class="processing" v-if="media.status === 'processing'">
                <span>Processing</span>
              </div>
              <div class="processing failed" v-if="media.status === 'failed'">
                <span>Failed</span>
              </div>
            </div>
            <div class="mediaName">
              <div class="mediaType xls" v-if="['application/x-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
                .includes(media.mimetype)"></div>
              <div class="mediaType zip" v-else-if="media.mimetype === 'application/zip'"></div>
              <div class="mediaType youtube" v-else-if="media.mimetype === 'video/youtube'"></div>
              <div class="mediaType" :class="media.type" v-else></div>
              {{media.name}}
            </div>
            <div class="actionMobile">
              <div class="mediaType" v-if="media.type === 'pdf'">PDF</div>
              <div class="mediaType" v-else>{{media.type.substr(0,1).toUpperCase()}}{{
                media.type.substr(1)}}
              </div>
              <div class="check" :class="{checked: media.checked}"
                v-on:click.stop="toggleSelect(index, media)"></div>
              <div class="star" :class="{starred: media.featured === 1}"
                v-on:click.stop="featured(index, media)"></div>
              <div class="more"
                v-on:click.stop="showMore = (showMore === media.id) ? null : media.id">
                <div class="actionCnt" v-if="showMore === media.id">
                  <div class="actionItem" v-if="media.type === 'image'"
                    v-on:click.stop="copyUrl(media)">
                    <img src="../assets/copy.png"> Copy media url
                  </div>
                  <div class="actionItem" v-on:click.stop="moveToFolder(media, index)">
                    <img src="../assets/move-to-folder.png"> Move to folder
                  </div>
                  <div class="divider"></div>
                  <div class="actionItem red" v-on:click.stop="deleteMedia2(media, index)"
                    v-if="media.isDeleted === 1">
                    <img src="../assets/delete.png"> Delete Permanently
                  </div>
                  <div class="actionItem red" v-on:click.stop="deleteMedia(media, index)"
                    v-else>
                    <img src="../assets/delete.png"> Delete
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tableInfo" v-if="!loading">
        Displaying {{allMedia.length.toLocaleString('id')}}
        of {{total.toLocaleString('id')}}
        items<br />&copy; {{$config.copyright}}. Powered by <a href="https://cmsriver.com"
        target="_blank">CMSRiver</a>
      </div>
    </perfect-scrollbar>

    <div class="mediaFooter" :class="{open: selectedMedia.length > 0 && !loading}">
      <span>
        {{selectedMedia.length}} media selected
        <b class="clearSelection" v-on:click="clearSelection">Clear Selection</b>
      </span>
      <div class="btnCnt">
        <button class="mfa mfa-move2dir" v-on:click="moveToFolderSelected"
          v-if="tabActive !== 'deleted'">
          <img src="../assets/move-to-folder.png">
          Move to folder
        </button>
        <button class="mfa mfa-delete" v-on:click="deleteSelected">
          <img src="../assets/delete.png">
          Delete Selected
          <template v-if="tabActive === 'deleted'">Permanently</template>
        </button>
      </div>
    </div>

    <Confirmation ref="confirmDialog"/>
    <MediaDetail ref="mediaDetail"/>
    <MediaCopy ref="mediaCopy"/>
    <FormInputerShort ref="formInputer"/>
    <DirSelector ref="dirSelector"/>
    <Snackbar ref="snackbar"/>
    <LoadingDialog ref="loadingDialog"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Confirmation from '@/components/Confirmation.vue';
import MediaDetail from '@/components/MediaDetail.vue';
import MediaCopy from '@/components/MediaCopy.vue';
import DirSelector from '@/components/DirSelector.vue';
import FormInputerShort from '@/components/FormInputerShort.vue';
import Snackbar from '@/components/Snackbar.vue';
import LoadingDialog from '@/components/LoadingDialog.vue';

export default {
  name: 'media',
  components: {
    Confirmation,
    MediaDetail,
    MediaCopy,
    FormInputerShort,
    DirSelector,
    Snackbar,
    LoadingDialog,
  },
  data() {
    return {
      limit: 25,
      page: 0,
      total: 0,
      loading: true,
      allMedia: [],
      directories: [],
      deleteConfirmation: false,
      deleteTitle: '',
      deleteDesc: '',
      mediaWillDelete: null,
      showMore: null,
      query: '',
      tabActive: 'all',
      configOpen: false,
      filetype: 'all',
      viewType: 'grid',
      searchTimer: null,
      moreOpen: false,
      dir: null,
      selectedMedia: [],
    };
  },
  methods: {
    ...mapActions(['chTitle', 'chCGB', 'chDirId']),
    doNothing() {},
    featured(i, media) {
      const ftr = (media.featured === 1) ? 0 : 1;
      this.allMedia[i].featured = ftr;
      this.$http.get(this.$config.uri(`media/${media.id}/featured/${ftr}`));
    },
    newFolder() {
      this.$refs.formInputer.open({
        title: 'New Folder',
        placeholder: 'Folder Name',
        action: 'Save',
      }, (b, v) => {
        if (!b) return;
        this.$http.post(this.$config.uri('media/directory/add'), {
          name: v,
        }).then(() => {
          this.getData();
        });
      });
    },
    search(e) {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        if (this.query && this.query !== '') this.page = 0;
        this.getData();
      }, 500);
    },
    gotoPage() {
      this.$refs.confirmDialog.open({
        title: 'Go To Page',
        desc: 'Input page number below',
        input: 'Page number...',
        action: 'Go To Page',
      }, (b, c, d) => {
        if (!b) return;
        const page = Number(d);
        if (Number.isNaN(page)) return;
        this.page = page - 1;
        window.history.replaceState({}, `page-${this.page}`, `${this.$config.appPath}media/all?tab=${this.tabActive}&page=${this.page}`);
        this.getData();
      });
    },
    nextPage() {
      if (((this.page * this.limit) + this.allMedia.length) >= this.total) return;
      this.page += 1;
      window.history.replaceState({}, `page-${this.page}`, `${this.$config.appPath}media/all?tab=${this.tabActive}&page=${this.page}`);
      this.getData();
    },
    prevPage() {
      if (this.page === 0) return;
      this.page -= 1;
      window.history.replaceState({}, `page-${this.page}`, `${this.$config.appPath}media/all?tab=${this.tabActive}&page=${this.page}`);
      this.getData();
    },
    selectTab(tab) {
      if (tab === this.tabActive) return;
      this.tabActive = tab;
      this.page = 0;
      window.history.replaceState({}, tab, `${this.$config.appPath}media/all?tab=${tab}&page=${this.page}`);
      this.getData();
    },
    setViewType(viewType) {
      this.configOpen = false;
      this.viewType = viewType;
      localStorage.setItem('viewType', viewType);
    },
    setFiletype(filetype) {
      this.configOpen = false;
      this.filetype = filetype;
      this.page = 0;
      this.getData();
    },
    setItemPerPage(itemPerPage) {
      this.configOpen = false;
      this.limit = itemPerPage;
      this.getData();
    },
    save() {
      this.draftStatus = 'loading';
      this.$http.post(this.$config.uri('page/config/homepage'), this.model).then((response) => {
        this.draftStatus = 'saved';
        setTimeout(() => {
          this.draftStatus = null;
        }, 1200);
      });
    },
    fieldChanged(e, field) {
      this.model[field] = e.target.innerHTML;
    },
    copyUrl(item) {
      this.showMore = null;
      this.$refs.mediaCopy.open(item);
    },
    clearSelection() {
      let i = 0;
      // eslint-disable-next-line
      for (const media of this.allMedia) {
        if (media.checked) this.toggleSelect(i, media);
        i += 1;
      }
    },
    toggleSelect(i, item) {
      item.checked = !item.checked; // eslint-disable-line
      if (item.checked) {
        this.selectedMedia.push(item);
      } else {
        let mediaIdx = 0;
        // eslint-disable-next-line
        for (const media of this.selectedMedia) {
          if (media.id === item.id) {
            this.selectedMedia.splice(mediaIdx, 1);
            break;
          }
          mediaIdx += 1;
        }
      }
    },
    deleteSelected() {
      if (this.tabActive === 'deleted') {
        this.$refs.confirmDialog.open({
          title: 'Delete Media Permanently',
          desc: 'Are you sure you want to delete selected media permanently?',
        }, (b) => {
          if (!b) return;
          this.$refs.formInputer.open({
            title: 'Input Password',
            subtitle: `To prevent from accidentally deleted media,
              you need to input your password.`,
            placeholder: 'Password',
            type: 'password',
            action: 'Delete Media',
          }, async (b2) => {
            if (!b2) return;
            this.$refs.loadingDialog.open();
            // eslint-disable-next-line
            for (const item of this.selectedMedia) {
              // eslint-disable-next-line
              await this.$http.get(this.$config.uri(`media/${item.id}/delete2`));
            }
            this.$refs.loadingDialog.close();
            this.getData();
          });
        });
      } else {
        this.$refs.confirmDialog.open({
          title: 'Delete Selected Media',
          desc: 'Are you sure you want to delete selected media?',
        }, async (b) => {
          if (!b) return;
          this.$refs.loadingDialog.open();
          // eslint-disable-next-line
          for (const item of this.selectedMedia) {
            // eslint-disable-next-line
            await this.$http.get(this.$config.uri(`media/${item.id}/delete`));
          }
          this.$refs.loadingDialog.close();
          this.getData();
        });
      }
    },
    moveToFolderSelected() {
      if (this.selectedMedia.length < 1) return;
      this.$refs.dirSelector.open(this.selectedMedia[0], async (b, m) => {
        if (!b) return;
        this.loading = true;
        // eslint-disable-next-line
        for (const item of this.selectedMedia) {
          // eslint-disable-next-line
          await this.$http.get(this.$config.uri(`media/${item.id}/move/${m.id}`));
        }
        this.selectedMedia = [];
        this.$refs.snackbar.open({ content: 'Content moved to directory' });
        this.getData();
      });
    },
    moveToFolder(item, i) {
      this.showMore = null;
      this.$refs.dirSelector.open(item, (b, m) => {
        if (!b) return;
        this.loading = true;
        this.$http.get(this.$config.uri(`media/${item.id}/move/${m.id}`)).then((r) => {
          if (r.data.status === 200) {
            this.$refs.snackbar.open({ content: 'Content moved to directory' });
          } else if (r.data.status === 403) {
            this.$refs.confirmDialog.open({
              title: 'Move Failed',
              desc: 'Can not move directory to itself',
              error: true,
            });
          }
          this.getData();
        });
      });
    },
    deleteMedia2(item, i) {
      this.showMore = null;
      this.$refs.confirmDialog.open({
        title: 'Delete Media',
        desc: 'Are you sure you want to delete this media permanently?',
      }, (b) => {
        if (!b) return;
        this.$refs.formInputer.open({
          title: 'Input Password',
          subtitle: `To prevent from accidentally deleted media,
            you need to input your password.`,
          placeholder: 'Password',
          type: 'password',
          action: 'Delete Media',
        }, (b2) => {
          if (!b2) return;
          this.allMedia.splice(i, 1);
          this.$http.get(this.$config.uri(`media/${item.id}/delete2`)).then(() => {});
        });
      });
    },
    deleteMedia(item, i) {
      this.showMore = null;
      this.$refs.confirmDialog.open({
        title: 'Delete Media',
        desc: 'Are you sure you want to delete this media?',
      }, (b) => {
        if (!b) return;
        this.allMedia.splice(i, 1);
        this.$http.get(this.$config.uri(`media/${item.id}/delete`)).then(() => {});
      });
    },
    dirBack() {
      this.dir = this.dir.parent || null;
      this.getData();
    },
    mediaDetail(i, item) {
      if (this.selectedMedia.length > 0) {
        this.toggleSelect(i, item);
        return;
      }

      if (item.type === 'directory') {
        this.dir = item;
        this.page = 0;
        this.getData();
        return;
      }
      this.$refs.mediaDetail.open(item, () => {
        // this.getData();
      });
    },
    getData() {
      this.loading = true;
      this.selectedMedia = [];
      let uri = `media/all?limit=${this.limit}&page=${this.page}`
        + `&status=${this.tabActive}&type=${this.filetype}&q=${this.query}`;
      if (this.dir) uri += `&directoryId=${this.dir.id}`;
      this.$http.get(this.$config.uri(uri)).then((r) => {
        this.loading = false;
        this.allMedia = (r.data.status === 200) ? r.data.data : [];
        this.total = (r.data.status === 200) ? r.data.total : 0;
      });
    },
  },
  mounted() {
    this.chTitle('Media Manager');
    this.chCGB(false);
    this.chDirId(0);
    this.viewType = localStorage.getItem('viewType') || 'grid';
    this.page = this.$route.query.page ? Number(this.$route.query.page) : 0;
    if (Number.isNaN(this.page)) this.page = 0;
    this.tabActive = this.$route.query.tab || 'all';
    this.getData();
  },
};
</script>

<style scoped lang="scss">
.lBtn.add.newFolder{
  border-color: #ddd;
  color: #444;
  padding-left: 38px;
  &:hover{
    background-color: #fff;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
    border-color: #ccc;
  }
  &:before{
    background-image: url(../assets/folder.png);
    left: 12px;
  }
}
.dirNav{
  border-bottom: #eee 1px solid;
  height: 50px;
  margin: 0 -30px;
  padding: 0 30px;
  display: flex;
  align-items: center;
  h4{
    margin: 0;
    font-size: 16px;
    font-weight: 600;
  }
  .backBtn{
    width: 34px; height: 34px;
    border-radius: 50%;
    background-size: 18px auto;
    background-position: center;
    background-repeat: no-repeat;
    margin-right: 10px;
    cursor: pointer;
    background-image: url(../assets/back-arrow.png);
    &:hover{
      background-color: #eee;
    }
  }
}
.tabCnt{
  .tab{
    width: 33.3333%;
  }
}
.loading{
  position: absolute;
  left: 0; right: 0; bottom: 0; top: 0;
  background-image: url(../assets/loading-2.svg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 46px auto;
}
.tableInfo{
  padding-top: 0;
}
.tabbleWrapper{
  min-height: calc(100vh - 200px);
}
.mediaCnt{
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 20px 20px;
  .mediaHeader{
    display: none;
  }
  .mediaItemCnt{
    width: calc(20% - 20px);
    margin: 0 10px 20px;
    position: relative;
    transition: box-shadow .3s ease;
    border: #eee 1px solid;
    border-radius: 7px;
    box-sizing: border-box;
    cursor: pointer;
    &:hover{
      box-shadow: 2px 2px 4px rgba(0,0,0,.1);
    }
    &.optionOpen{
      z-index: 991;
    }
    @media (max-width: 1460px) {
      width: calc(25% - 20px);
    }
    @media (max-width: 1340px) {
      width: calc(33.333333% - 20px);
    }
    &.directory{
      .mediaName{
        padding-left: 14px;
        font-weight: 600;
      }
    }
  }
  .mediaName{
    font-size: 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    padding: 12px 114px 12px 42px;
    position: relative;
    .mediaType{
      width: 26px;
      height: 26px;
      border-radius: 3px;
      position: absolute;
      z-index: 2;
      top: 9px; left: 10px;
      background-size: 22px auto;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url(../assets/mediatype/general-file.png);
      &.directory{
        display: none;
      }
      &.video{
        background-image: url(../assets/mediatype/video.png);
      }
      &.zip{
        background-image: url(../assets/mediatype/zip.png);
      }
      &.pdf{
        background-image: url(../assets/mediatype/pdf.png);
        background-size: 20px auto;
      }
      &.youtube{
        background-image: url(../assets/mediatype/youtube.png);
      }
      &.image{
        background-image: url(../assets/mediatype/image.png);
        background-size: 24px 20px;
      }
      &.audio{
        background-image: url(../assets/mediatype/audio.png);
      }
      &.xls{
        background-image: url(../assets/mediatype/xls.png);
      }
    }
  }
  .delete, .edit, .more, .star, .check{
    width: 30px;
    height: 30px;
    background-color: #fff;
    border-radius: 50%;
    position: absolute;
    z-index: 9;
    right: 8px; top: 6px;
    background-image: url(../assets/more.png);
    background-size: 16px auto;
    background-position: center;
    background-repeat: no-repeat;
    &:hover{
      cursor: pointer;
      box-shadow: 2px 2px 4px rgba(0,0,0,.1);
      // background-color: #ccc;
    }
    .actionCnt{
      position: absolute;
      background: #fff;
      top: 100%; right: 0;
      // border: 1px solid #ccc;
      box-shadow: 1px 1px 4px rgba(0,0,0,.2);
      border-radius: 10px;
      padding: 10px 0;
      white-space: nowrap;
      text-align: left;
      z-index: 4;
      .divider{
        border-top: #eee 1px solid;
        padding-top: 4px;
        margin-top: 4px;
      }
      .actionItem{
        display: block;
        cursor: pointer;
        list-style: none;
        padding: 7px 42px;
        color: #444;
        font-size: 14px;
        min-width: 100px;
        &.red{
          color: red;
        }
        img{
          height: 15px;
          margin: -4px 4px -2px -22px;
        }
      }
      .actionItem.actionRed{
        color: red;
      }
      .actionItem:hover{
        background-color: #eee;
      }
    }
  }
  .star{
    right: 42px;
    background-image: url(../assets/star.png);
    &.starred{
      background-image: url(../assets/star-active.png);
    }
  }
  .check{
    right: 82px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: none;
    &:before{
      content: "";
      border: #999 2px solid;
      display: block;
      width: 12px; height: 12px;
      border-radius: 3px;
      transition: all .3s ease;
      background-size: 12px auto;
      background-position: center;
      background-repeat: no-repeat;
    }
    &:hover{
      &:before{
        border-color: #767676;
      }
    }
    &.checked{
      &:before{
        background-color: #0067ff;
        border-color: #0067ff;
        background-image: url(../assets/checked.png);
      }
    }
  }
  .actionMobile{
    position: absolute;
    right: 4px; bottom: 4px;
    display: flex;
    align-items: center;
    .star, .more, .check{
      position: static;
      width: 34px; height: 34px;
      margin-left: 2px;
    }
    .mediaType{
      display: none;
    }
    .actionCnt{
      margin-top: -14px;
      margin-right: -10px;
      top: auto; bottom: 100%;
    }
  }
  .mediaItem{
    width: 100%;
    height: 12vw;
    border-radius: 5px;
    position: relative;
    // overflow: hidden;
    @media (max-width: 1340px) {
      height: 16vw;
    }
    .mediaThumb{
      position: absolute;
      left: 0; right: 0; top: 0; bottom: 0;
      background-size: cover;
      background-color: #fff;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 7px;
      &.png{
        background-size: 40% auto;
      }
      &.gif{
        // background-size: contain;
      }
      &.directory{
        background-color: transparent;
        background-size: 60% auto;
        background-image: url(../assets/folder-thumb.png);
        opacity: 1;
      }
      &.general{
        background-size: 74px auto;
        background-image: url(../assets/mediatype/general-file.png);
        &.xls{
          background-image: url(../assets/mediatype/xls-big.png);
        }
        &.zip{
          background-image: url(../assets/mediatype/zip.png);
        }
        &.pdf{
          background-image: url(../assets/mediatype/pdf-big.png);
        }
        &.audio{
          background-color: transparent;
          background-image: url(../assets/mediatype/audio.png);
        }
      }
    }
    .star, .more, .check{
      display: none;
    }
    .audio, .html, .processing{
      background-color: #d9d6e4;
      position: absolute;
      left: 0; right: 0; top: 0; bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding: 0 20px;
      border-radius: 3px;
      .audioIcon, .htmlIcon{
        width: 46px;
        height: 46px;
        background-image: url(../assets/musical-note.svg);
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        margin: 0 auto 12px;
        margin: 0 auto;
      }
      .htmlIcon{
        background-image: url(../assets/html.png);
      }
      &.pdf{
        background-color: #efe5db;
        .audioIcon{
          background-image: url(../assets/pdf-file.png);
        }
      }
      &.youtube{
        background-color: #efe5db;
        .audioIcon{
          background-image: url(../assets/youtube-white.png);
        }
      }
      h4{
        margin: 0;
        font-size: 16px;
        line-height: 1.3;
        display: none;
        @media (max-width: 1300px) {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 140px;
        }
      }
    }
    .html{
      background-color: #ffefe4;
    }
    .processing{
      z-index: 1;
      background: orange !important;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      span{
        position: relative;
        z-index: 3;
        color: #444;
        font-size: 12px;
        font-size: 24px;
      }
      @-webkit-keyframes MOVE-BG {
        from {
          -webkit-transform: translateX(0);
        }
        to {
          -webkit-transform: translateX(46px);
        }
      }
      @keyframes MOVE-BG {
        from {
          transform: translateX(0);
        }
        to {
          transform: translateX(46px);
        }
      }
      &:before{
        display: block;
        content: "";
        position: absolute;
        left: -46px;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 1;
        background: -webkit-repeating-linear-gradient(
          145deg,
          rgba(0,0,0,.1) 1px,
          rgba(0,0,0,0) 2px,
          rgba(0,0,0,0) 11px,
          rgba(0,0,0,.1) 12px,
          rgba(0,0,0,.1) 20px
        );
        background: repeating-linear-gradient(
          -55deg,
          rgba(0,0,0,.1) 1px,
          rgba(0,0,0,0) 2px,
          rgba(0,0,0,0) 11px,
          rgba(0,0,0,.1) 12px,
          rgba(0,0,0,.1) 20px
        );
        -webkit-animation-name: MOVE-BG;
        -webkit-animation-duration: .6s;
        -webkit-animation-timing-function: linear;
        -webkit-animation-iteration-count: infinite;
        animation-name: MOVE-BG;
        animation-duration: .6s;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
      }
      &.failed{
        background: #f5f5f5 !important;
        span{
          color: red;
          font-weight: bold;
        }
        &:before{
          display: none;
        }
      }
    }
    .edit{
      right: 45px;
      background-image: url(../assets/edit.png);
    }
  }
  &.list{
    display: block;
    padding: 45px 0 30px;
    .mediaHeader{
      display: block;
      position: fixed;
      z-index: 997;
      left: 300px; right: 0;
      top: 144px;
      background-color: #fff;
      border-bottom: #eee 1px solid;
      padding: 12px 30px;
      color: #767676;
      .mediaType{
        position: absolute;
        right: 0; top: 0; bottom: 0;
        padding: 12px 0;
        width: 320px;
      }
    }
    .mediaItemCnt{
      width: auto;
      position: relative;
      min-height: 60px;
      margin: 0;
      padding-left: 84px;
      display: flex;
      align-items: center;
      border: none;
      border-radius: none;
      box-shadow: none;
      cursor: pointer;
      border-bottom: #eee 1px solid;
      &:hover{
        background-color: #f5f5fe;
      }
      .audioIcon, .htmlIcon{
        width: 24px; height: 24px;
      }
    }
    .mediaItem{
      position: absolute;
      left: 30px; top: 10px;
      width: 40px; height: 40px;
      box-shadow: none;
      .mediaThumb{
        background-size: cover;
        &.directory{
          background-color: transparent;
          background-image: url(../assets/folder-list.png);
          background-size: contain;
        }
        &.general{
          background-size: 26px auto;
        }
      }
      .more, .star, .check, .mediaType{
        display: none;
      }
    }
    .actionMobile{
      right: 20px; top: 0; bottom: 0;
      display: flex;
      align-items: center;
      width: 320px;
      box-sizing: border-box;
      padding-left: 20px;
      .star, .more, .check{
        position: static;
        width: 36px; height: 36px;
        margin-left: 4px;
      }
      .mediaType{
        display: block;
        width: 140px;
        font-weight: 600;
        margin-right: auto;
      }
      .actionCnt{
        margin-top: -14px;
        margin-right: 0;
        top: 100%; bottom: auto;
      }
    }
    .mediaName{
      font-weight: 600;
      font-size: 16px;
      padding-right: 360px;
      padding-left: 14px;
      .mediaType{
        display: none;
      }
    }
    .processing{
      span{
        display: none;
      }
    }
  }
}

.mediaFooter{
  position: fixed;
  left: 300px; right: 0; bottom: 0;
  height: 50px;
  background-color: #fff;
  border-top: #eee 1px solid;
  z-index: 9;
  bottom: -50px;
  transition: all .3s ease;
  display: flex;
  align-items: center;
  &.open{
    bottom: 0;
  }
  span{
    display: inline-block;
    line-height: 50px;
    padding-left: 20px;
    b{
      color: #0057d8;
      cursor: pointer;
      margin-left: 10px;
      font-weight: 500;
      &:hover{
        color: #0067ff;
      }
    }
  }
  .btnCnt{
    padding: 0 20px 0 0;
    margin-left: 20px;
    margin-right: auto;
    display: flex;
    align-items: center;
    .mfa{
      border: #ddd 1px solid;
      color: #444;
      background-color: #fff;
      border-radius: 50px;
      padding: 8px 14px;
      font-size: 14px;
      position: relative;
      padding-left: 40px;
      transition: all .3s ease;
      cursor: pointer;
      margin-right: 10px;
      &:hover{
        box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
        border-color: #ccc;
      }
      img{
        position: absolute;
        left: 13px; top: 50%;
        margin-top: -10px;
        height: 20px;
      }
      &.mfa-move2dir{
        img{
          margin-top: -11px;
        }
      }
      &.mfa-delete{
        img{
          height: 17px;
          margin-top: -9px;
        }
      }
    }
  }
}
</style>
